import { useContext, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';

import * as S from './styled';
import { HiOutlineMinusSm, HiOutlinePlusSm } from 'react-icons/hi';
import { FaRegCopy } from 'react-icons/fa';
import Globals from '../../../../../Globals.json';
import ModalADD from './ModalAdd';
import ModalCopy from '../../../CopyComplements';
import { useAppSelector } from '../../../../../redux/store';
import api from '../../../../../Services/api';
import { notifyError } from '../../../../notify/notify-component';
import tableStyleDefaultBolder from '../../../../../Services/tableStyleDefaultBolder';
import { paginationOptions } from '../../../../data/PagineteInfo';
import CustomLoader from '../../../../data/customLoader';
import { CategoryContext } from '../../../../../context/category';

export default function Associated({ isEditable }: { isEditable: boolean }) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  const { category, associatedComplement, setAssociatedComplement } =
    useContext(CategoryContext);

  const [modalAdd, setModalAdd] = useState<boolean>(false);
  const [modalCopy, setModalCopy] = useState<boolean>(false);
  const [selectedComplement, setSelectedComplement] = useState<
    number | undefined
  >(undefined);
  const [loading, setLoading] = useState<boolean>(false);

  const columns: any = [
    {
      name: 'Código',
      sortable: true,
      width: '100px',
      center: true,
      selector: (row: any) => row.id_pdv,
    },
    {
      name: 'Produto',
      minWidth: '190px',
      sortable: true,
      selector: (row: any) => {
        return (
          <div
            title="Selecionar"
            style={{
              cursor: 'pointer',
            }}
            onClick={() => handleSelectComplement(row)}
          >
            <span
              style={{ color: row.id === selectedComplement ? 'blue' : '' }}
            >
              {' '}
              {row.sale_name?.toLowerCase()}
            </span>
          </div>
        );
      },
    },
  ];

  const getCategories = () => {
    setLoading(true);
    const uri = `?paginate=false&store_id=${storeMe?.storeActive?.id}`;
    api
      .get(Globals.api.categories + `${uri}`)
      .then((response) => {
        const data = response?.data?.data?.find(
          (item: any) => item.id === category
        );

        setAssociatedComplement(data?.relationships.associateds);
      })
      .catch((error: any) => {
        notifyError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleRemove = async () => {
    try {
      // await api.delete(Globals.api.associates + `/${selectedComplement}`)

      setAssociatedComplement(
        associatedComplement.filter(
          (item: any) => item.uuid !== selectedComplement
        )
      );

      setSelectedComplement(undefined);
    } catch (error: any) {}
  };

  const handleSelectComplement = (complement: any) => {
    setSelectedComplement(complement.uuid);
  };

  useEffect(() => {
    !isEditable && getCategories();
  }, [category]);

  return (
    <>
      <S.Section>
        <div style={{ width: '100%' }}>
          <DataTable
            columns={columns}
            data={associatedComplement || []}
            striped
            pagination
            paginationPerPage={15}
            customStyles={tableStyleDefaultBolder}
            paginationComponentOptions={paginationOptions}
            progressPending={loading}
            progressComponent={<CustomLoader />}
            noDataComponent="Nenhuma extra encontrado."
          />
        </div>
        <S.ButtonGroup>
          <button onClick={() => setModalAdd(true)} type="button">
            <span>
              <HiOutlinePlusSm title="Adicionar" size={16} color="white" />
            </span>
            Adicionar
          </button>
          <button onClick={() => setModalCopy(true)} type="button">
            <span>
              <FaRegCopy title="Copiar" size={16} color="white" />
            </span>
            Copiar
          </button>
          <button
            disabled={selectedComplement === undefined ? true : false}
            onClick={handleRemove}
            type="button"
          >
            <span>
              <HiOutlineMinusSm title="Remover" size={16} color="white" />
            </span>
            Remover
          </button>
        </S.ButtonGroup>
      </S.Section>
      <ModalADD
        setShow={setModalAdd}
        show={modalAdd}
        associatedComplement={associatedComplement}
        setAssociatedComplement={setAssociatedComplement}
      />
      <ModalCopy
        kind="associateds"
        setShow={setModalCopy}
        show={modalCopy}
        list={associatedComplement}
        setList={setAssociatedComplement}
      />
    </>
  );
}
